function normalizeEmail(input: string): string {
  return input
    .replace(/\s/g, '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}

export { normalizeEmail };
